import React, { Component } from 'react'
import styles from '../scss/Download.scss';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

export class RequestView extends Component {

    state = {
        activeTab: "profiles"
    };

    componentDidMount() {
        this.restoreSettings();
    }

    restoreSettings = () => {
        const activeTab = localStorage.getItem("ActiveRequestTab");
        if (activeTab) {
            this.setState({
                activeTab: activeTab
            });
        }
    }
    
    tabSelectionChange = (activeTab) => {
        if (activeTab) {
            this.setState({
                activeTab: activeTab
            });
        }
        localStorage.setItem("ActiveRequestTab", activeTab);
    }
    
    setIsBusyStatus = (isBusy) => {
        if (this.props.onIsBusyChange) {
            this.props.onIsBusyChange(isBusy);
        }
    }

    render() {
        return (
            <div >
                <div className="request-preview">
                    <Tabs activeKey={this.state.activeTab}
                        onSelect={this.tabSelectionChange} id="option-tabs" className="mb-3">
                        <Tab eventKey="profiles" title="Beach Profile Data">
                            <div className="request-preview-container">
                                {this.props.profileDatasetsBySites.length > 0 ?
                                    <div>
                                        {
                                            this.props.profileDatasetsBySites.map((dataset, i) => {
                                                return (<div key={i}>
                                                    {dataset.site.description}

                                                    {dataset.surveys.map((survey, j) => {
                                                        return <dl key={j}>
                                                            <dt >{survey.name}</dt>
                                                            <dd>Transects: [{survey.transects}]</dd>
                                                        </dl>
                                                    })}

                                                </div>)
                                            })
                                        }
                                    </div> :
                                    <span>
                                        No beach profile dataset selected.
                                    </span>
                                }
                            </div>
                        </Tab>
                        <Tab eventKey="shapefiles" title="Geospatial Data">
                            <div className="request-preview-container">
                                {this.props.geoDatasetsBySites.length > 0 ?
                                    <div>
                                        {
                                            this.props.geoDatasetsBySites.map((dataset, i) => {
                                                return (<div key={i}>
                                                    {dataset.site.description}
                                                    {dataset.surveys.map((survey, j) => {
                                                        return <dl key={j}>
                                                            <dt>
                                                                {survey.name}
                                                            </dt>
                                                            {survey.layers.map((layer, k) => {
                                                                return <dd key={k}>{layer.layerName}</dd>
                                                            })}
                                                        </dl>
                                                    })}

                                                </div>)
                                            })
                                        }
                                    </div> :
                                    <span>
                                        No geospatial dataset selected.
                                    </span>
                                }
                            </div>
                        </Tab>
                    </Tabs>
                </div>
            </div>
        )
    }
}

export default RequestView
